import styled from "styled-components";
import { Input } from "@sonder/ui/source/styled/fragments/Input";
import { colors } from "@sonder/ui/source/styled/theme";

export const ListInput = styled(Input)`
  background: none;
  border: none;
  height: 100%;
  padding: 0;
  width: 100%;
  font-weight: normal;
  color: ${colors.gray4};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
